// eslint-disable-next-line import/no-unresolved
import api from './axios'

export default {
  getSession(credentials) {
    return api.post('/session', { ...credentials })
  }
}
